import gql from 'graphql-tag';

export const CCA_CATEGORIZE_ARTICLES_MUTATION = gql`
  mutation CcaCategorizeArticlesMutation($articleIds: [ID!]!) {
    ccaCategorizeArticles(articleIds: $articleIds) {
      articles {
        articleId
        categoryIds
        suggestedTemplateIds
      }
      errors
    }
  }
`;
